import convertImageToBlob from './convertImageToBlob';
const generateFormData = async (canvasElement) => {
	const blob = await convertImageToBlob(canvasElement);
	const formData = new FormData();
	formData.append('file', blob);
	return formData;
};
export default generateFormData;
